<!--
 * @Author: mazhigang
 * @Date: 2023-09-02 22:16:19
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-25 20:48:10
-->
<template>
  <div>
    <div class="box">
      <div style="display: flex;align-items: center;">
        <div class="logoBox">
          <div class="logo">
            <img src="/static/bigLogo.png" alt="" v-if="color == '#fff'" />
            <img src="/static/bigLogo1.png" alt="" v-else />
          </div>
          <!-- <div class="logoName">咖德保安</div> -->
        </div>
        <div class="titleBox">
          <div
            :class="['titleItem', item.name == selectData ? 'active' : '']"
            v-for="(item, index) in list"
            :key="index"
            :style="{ color: color }"
            @click="selectPage(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div style="display: flex;align-items: center;position: relative;">
        <div class="btn"></div>
        <div class="codeBox">
          <img src="../../static/qiweiCode.png" alt="" style="width: 100%;" />
          <div style="font-size: 16px;">商务合作咨询</div>
        </div>
        <a
          style="color: #fff;"
          class="kefu"
          target="_blank"
          href="https://work.weixin.qq.com/kfid/kfce3086cb4030f1cb8"
        >
          <!-- <img
            src="../../static/kefuzixun.png"
            alt=""
            class="kefu"
            style="width: 120px;height: 38px;"
          /> -->
          <div class="btn1"></div>
        </a>
        <div class="codeBox1">
          <img src="../../static/kefuCode.png" alt="" style="width: 100%;" />
          <div style="font-size: 16px;">扫码联系客服</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        { name: "首页", path: "/index" },
        { name: "招聘端", path: "/plan" },
        { name: "保安端", path: "/cooperate" },
        { name: "保安来了", path: "/askri" },
        { name: "关于我们", path: "/about" }
      ],
      selectData: {},
      scrollTop: 0
    };
  },
  props: {
    color: {
      type: String,
      default: "#000"
    }
  },
  created() {
    let val = this.$route.path;
    for (var i = 0; i < this.list.length; i++) {
      if (val == this.list[i].path) {
        this.selectData = this.list[i].name;
      }
    }
  },
  watch: {
    $route(to, from) {
      let val = to.fullPath;
      for (var i = 0; i < this.list.length; i++) {
        if (val == this.list[i].path) {
          this.selectData = this.list[i].name;
        }
      }
    }
  },
  methods: {
    handleScroll() {
      // 兼容性写法（现代浏览器一般直接用 window.pageYOffset 即可）
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop > 10) {
        this.bgcolor = 0;
      } else {
        this.bgcolor = 1;
      }
    },
    selectPage(val) {
      this.selectData = val.name;
      this.$router.push(val.path);
    }
  }
};
</script>
<style scoped>
.codeBox {
  width: 172px;
  height: 211px;
  background-image: url("../../static/codeBg.png");
  background-size: 100% 100%;
  box-shadow: 0px 2px 25px 0px rgba(27, 51, 112, 0.1);
  position: absolute;
  left: -60px;
  top: 60px;
  display: none;
  padding: 20px 10px 0 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 12px;
}
.codeBox1 {
  width: 172px;
  height: 211px;
  background-image: url("../../static/codeBg.png");
  background-size: 100% 100%;
  box-shadow: 0px 2px 25px 0px rgba(27, 51, 112, 0.1);
  position: absolute;
  left: 20px;
  top: 60px;
  display: none;
  padding: 20px 10px 0 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 12px;
}
.box {
  padding: 12px 12px;
  box-sizing: border-box;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.btn {
  width: 120px;
  height: 38px;
  background-image: url("../../static/zixun.png");
  background-size: 100% 100%;
  margin-right: 20px;
}
.btn1 {
  width: 120px;
  height: 38px;
  background-image: url("../../static/kefuzixun.png");
  background-size: 100% 100%;
}
.btn:hover + .codeBox {
  display: block;
}
.kefu:hover + .codeBox1 {
  display: block;
}
.logoBox {
  display: flex;
  align-items: center;
}
.logo img {
  width: 80pxpx;
  height: 31px;
  /* margin-right: 9px;
  margin-top: 4px; */
}
.logoName {
  color: #1677ff;
  font-weight: 700;
  font-size: 16px;
}
.titleBox {
  display: flex;
  margin-left: 100px;
}
.titleItem {
  cursor: pointer;
  font-size: 13px;
  color: #fff;
  margin-left: 38px;
  line-height: 40px;
}
.titleBox:first-child {
  margin-left: 0;
}
.active {
  height: 36px;
  color: #fff;
  border-bottom: #1677ff solid 2px;
  font-weight: bold;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/pageTitle.vue